var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    enableBackground: "new 0 0 22 22",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 22,
    height: 22,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAAChklEQVR4nO3dvXLTQBiF4ZefkoIOhtSpfUXcXygypGGGgguAkquIQ4YZ4jF1KBwXlhVJtnatI/M+M1vE1kqfdGaj1ebHUMclcA2sgMdGWwGfgItKxy5h7vXvuAR+s38izXZP5knNvf491/SfzLZdTVRjl7nXv6dtmD/X/kxUY5dJ639ReodsCu06Rt/7U5u0/pcld6bxDCSMgYR5LpAFcAMsGX6D27ZDHbr/2q12/bdsru1i6AEWwLriCU59wVPqXzMwlJuZnNDcA3kEPjd33jZlWwLvWl4/Vt+0MV3N+n/RuNZtgTQPeOg8u6//2P3XVrv+zv7OssIYSBgDCVMjkFXj665Zy0OF4481af01AvlaadtTiau/bx7e54LND2/65uD3wIcC9ZZWu/6Dr+/YQGBT6BWbId3c38PTe4lhbNWsv/P61ngOUTefQ+bEQMIYSBgDCWMgYV4P2GZuy+Wz5ggJYyBhDCTMkHuIT+pldd6THSFhDCSMgYQxkDAGEsZAwhhImCHPIYf639a+/Auqc2YgYQwkTI17SNPQ77HH/rbL1P2KcoSEMZAwBhLGQMIYSBgDCWMgYQwkjIGEOcWT+rFPtnPpV5QjJIyBhDGQMK72ju9XlCMkjIGEMZAwBhLGQMIYSBgDCWMgYQwkjKu94/sV5QgJYyBhDCSMq73j+xXlCAljIGEMJIyBhDGQMAYSxkDCGEgYAwnjau/4fkU5QsIYSBgDCVPjHuJ/MR3BERLGQMIYSBgDCWMgYQwkjIGEaXsOuWP3Q9cj1njO1G3zhbYR8v0EhWjjx5CNFsCa/s+CtY1rf5+u9Y5XLYHcAV+A98Bb4E3LNjreEvgGfAR+TlyLJOmM/ANpqAXcSfB8pwAAAABJRU5ErkJggg=="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.4653e262.svg";
export { ForwardRef as ReactComponent };